// WIP
// TODO add new import dialog types

export enum ImportSubjectType {
    TASTINGS_EVALS = 'tastings_evaluations',
    TASTINGS_EVAL_REIMPORT = 'tastings_evaluation_reimport',
}